import React from "react";
import { Helmet } from "react-helmet-async";
import img1 from "../assets/galleryassests/1.jpg";
import img2 from "../assets/galleryassests/2.jpg";
import img3 from "../assets/galleryassests/3.jpg";
import img4 from "../assets/galleryassests/4.jpg";
import img5 from "../assets/galleryassests/5.jpg";
import img6 from "../assets/galleryassests/6.jpg";
import img7 from "../assets/galleryassests/7.jpg";
import img8 from "../assets/galleryassests/8.jpg";
import img9 from "../assets/galleryassests/9.jpg";
// import img10 from "../assets/galleryassests/10.jpg";
import img11 from "../assets/galleryassests/11.jpg";

import img13 from "../assets/galleryassests/13.jpg";
import img14 from "../assets/galleryassests/14.jpg";
import img16 from "../assets/galleryassests/16.jpg";
import img17 from "../assets/galleryassests/17.jpg";

// new images
import img19 from "../assets/galleryassests/19.jpg";
import img20 from "../assets/galleryassests/20.jpg";
import img21 from "../assets/galleryassests/21.jpg";
import img22 from "../assets/galleryassests/22.jpg";
import img23 from "../assets/galleryassests/23.jpg";
import img24 from "../assets/galleryassests/24.jpg";
import img25 from "../assets/galleryassests/25.jpg";
import img26 from "../assets/galleryassests/26.jpg";
import img27 from "../assets/galleryassests/27.jpg";
import img28 from "../assets/galleryassests/28.jpg";
import img29 from "../assets/galleryassests/29.jpg";
import img30 from "../assets/galleryassests/30.jpg";
import img32 from "../assets/galleryassests/32.jpg";
import img33 from "../assets/galleryassests/33.jpg";
import img34 from "../assets/galleryassests/34.jpg";
import img35 from "../assets/galleryassests/35.jpg";
import img36 from "../assets/galleryassests/36.jpg";
import img37 from "../assets/galleryassests/37.jpg";
import img38 from "../assets/galleryassests/38.jpg";
import img39 from "../assets/galleryassests/39.jpg";
import img40 from "../assets/galleryassests/40.jpg";
import img41 from "../assets/galleryassests/41.jpg";
import img42 from "../assets/galleryassests/42.jpg";
import img43 from "../assets/galleryassests/43.jpg";
import img44 from "../assets/galleryassests/44.jpg";
import img45 from "../assets/galleryassests/45.jpg";
import img46 from "../assets/galleryassests/46.jpg";
import img47 from "../assets/galleryassests/47.jpg";
import img48 from "../assets/galleryassests/48.jpg";

const images = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,

  img11,
  // img12,
  img13,
  img14,

  img16,
  img17,

  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  // img31,
  img32,
  img33,
  img34,
  img35,
  img36,
  img37,
  img38,
  img39,
  img40,
  img41,
  img42,
  img43,
  img44,
  img45,
  img46,
  img47,
  img48,
];

export default function Gallery() {
  return (
    <>
      <Helmet>
        <title>Gallery - ANS Safety Nets</title>
        <meta
          name="description"
          content="Explore the gallery of ANS Safety Nets to see our high-quality safety net installations across Bengaluru, including balcony safety nets, children safety nets, industrial safety nets, and more."
        />
        <meta
          name="keywords"
          content="Gallery of ANS Safety Nets, Safety Nets in Bengaluru, Balcony Safety Nets in Bengaluru, Children Safety Nets in Bengaluru, Industrial Safety Nets in Bengaluru, Pets Safety Nets in Bengaluru, Ducteria Nets in Bengaluru, Monkey Safety Nets in Bengaluru, Cricket Practice Nets in Bengaluru, Bird Spikes in Bengaluru"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link rel="canonical" href="https://www.anssafetynets.com/gallery" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Gallery - ANS Safety Nets",
            description:
              "Explore the gallery of ANS Safety Nets to see our high-quality safety net installations across Bengaluru, including balcony safety nets, children safety nets, industrial safety nets, and more.",
            url: "https://www.anssafetynets.com/gallery",
            breadcrumb: {
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item: "https://www.anssafetynets.com",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Gallery",
                  item: "https://www.anssafetynets.com/gallery",
                },
              ],
            },
            publisher: {
              "@type": "Organization",
              name: "ANS Safety Nets",
              logo: {
                "@type": "ImageObject",
                url: "https://www.anssafetynets.com/logo.png",
                width: 250,
                height: 100,
              },
            },
            about: {
              "@type": "Service",
              name: "Safety Nets Installation in Bengaluru",
              serviceType: [
                "Balcony Safety Nets",
                "Children Safety Nets",
                "Industrial Safety Nets",
                "Pets Safety Nets",
                "Ducteria Nets",
                "Monkey Safety Nets",
                "Cricket Practice Nets",
                "Bird Spikes",
              ],
              areaServed: "Bengaluru",
              provider: {
                "@type": "Organization",
                name: "ANS Safety Nets",
                url: "https://www.anssafetynets.com",
              },
            },
          })}
        </script>
      </Helmet>
      <div className="pt-16">
        {/* Hero Section */}
        <div className="bg-[#2c3639]  py-20">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-white mb-4 px-[5px]">
              Excellence in Every Detail
            </h1>
            <i className="text-xl text-white">
              Step Into Our World of Safe, Stunning, and Smart Solutions!
            </i>
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="py-20">
          <div className="galleryIMgcontainer">
            <div className="masonry-grid">
              {images.map((image, index) => (
                <div key={index} className="masonry-item">
                  <img
                    src={image}
                    alt="ANS SAFETY NETS ,safety nets in bengaluru,"
                    tittle="ANS SAFETY NETS ,safety nets in bengaluru,safety nets, no 01 safety nets Balcony Safety Nets,
Children Safety Nets,
Industrial Safety Nets,
Pets Safety Nets,
Ducteria Nets,
Monkey Safety Nets,
Cricket Practice Nets,
Bird Spikes"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
